import { render, staticRenderFns } from "./SpecialOtherVerbiageModal.vue?vue&type=template&id=1ff151aa"
import script from "./SpecialOtherVerbiageModal.vue?vue&type=script&lang=ts"
export * from "./SpecialOtherVerbiageModal.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports